import { useAppTheme } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'
import { StyleSheet, View, type ViewProps, type ViewStyle } from 'react-native'

export type ViewPropsGrid = ViewProps & {
  relative?: boolean
  center?: boolean
  gap?: ViewStyle['gap']
  flex?: ViewStyle['flex']
  align?: ViewStyle['alignItems']
  justify?: ViewStyle['justifyContent']
  wrap?: ViewStyle['flexWrap']
  direction?: ViewStyle['flexDirection']
}

// общая для всех функция для расчета макета
export function gridPropsParse(props: ViewPropsGrid) {
  const style: ViewStyle[] = []

  if (props.align) style.push({ alignItems: props.align })

  if (props.justify) style.push({ justifyContent: props.justify })

  if (props.relative) style.push({ position: 'relative' })

  if (props.gap !== undefined) style.push({ gap: typeof props.gap === 'number' ? rw(props.gap) : props.gap })

  if (props.flex !== undefined) style.push({ flex: props.flex })

  if (props.wrap !== undefined) style.push({ flexWrap: props.wrap })

  if (props.center !== undefined) style.push({ alignItems: 'center', justifyContent: 'center' })

  if (props.direction !== undefined) style.push({ flexDirection: props.direction })

  return StyleSheet.flatten(style)
}

type ContainerProps = ViewPropsGrid & {
  offset?: number
}

// eslint-disable-next-line kartoy/components-props-limit
export function Container({
  style,
  offset,
  gap,
  align,
  justify,
  relative,
  flex,
  wrap,
  center,
  direction,
  ...rest
}: ContainerProps) {
  const { SIZE_CONTAINER_PADDING } = useAppTheme()
  const local = gridPropsParse({ gap, align, justify, relative, flex, wrap, center, direction })
  const additional: ViewStyle = {
    paddingHorizontal: offset !== undefined ? SIZE_CONTAINER_PADDING + offset : SIZE_CONTAINER_PADDING,
  }
  return <View {...rest} style={[local, additional, style]} />
}

// eslint-disable-next-line kartoy/components-props-limit
export function Column({
  style,
  gap,
  align,
  justify,
  relative,
  flex,
  wrap,
  center,
  ...rest
}: Omit<ViewPropsGrid, 'direction'>) {
  const local = gridPropsParse({ gap, align, justify, relative, flex, wrap, center })
  return <View {...rest} style={[{ flexDirection: 'column' }, local, style]} />
}

// eslint-disable-next-line kartoy/components-props-limit
export function Row({
  style,
  gap,
  align,
  justify,
  relative,
  flex,
  wrap,
  center,
  ...rest
}: Omit<ViewPropsGrid, 'direction'>) {
  const local = gridPropsParse({ gap, align, justify, relative, flex, wrap, center })
  return <View {...rest} style={[{ flexDirection: 'row' }, local, style]} />
}

type SpaceProps = ViewProps & {
  size?: number
  horizontal?: boolean
}

// eslint-disable-next-line kartoy/components-props-limit
export function Space({ style, size, horizontal, ...rest }: SpaceProps) {
  const { SIZE_CONTAINER_PADDING } = useAppTheme()
  const label = horizontal ? 'width' : 'height'
  return <View {...rest} style={[{ [label]: size === undefined ? rh(SIZE_CONTAINER_PADDING) : rh(size) }, style]} />
}

// eslint-disable-next-line kartoy/components-props-limit
export function Flex({ style, gap, align, justify, relative, flex, wrap, center, direction, ...rest }: ViewPropsGrid) {
  const local = gridPropsParse({ gap, align, justify, relative, wrap, center, direction })
  const flexStyle: ViewStyle = { flex: flex === undefined ? 1 : flex }
  return <View {...rest} style={[local, flexStyle, style]} />
}
